import policyholderDetails from './policyholder-details.ar'
import professionalInfo from './professional-info.ar'
import quoteRequestStepper from './quote-request-stepper.ar'
import declarations from './declarations.ar'
import quoteList from './quote-list.ar'
import dashboard from './dashboard.ar'
import drsLounge from './drs-lounge.ar'
import summaryAndPayment from './summary-and-payment.ar'
import paymentResult from './payment-result.ar'
import policyRenewal from './policy-renewal.ar'
import quoteExpiredPopup from './quote-expired-popup.ar'
import faq from './faq.ar'
import cancellation from './cancellation.ar'
import iban from './iban.ar'
import ehsan from './ehsan.ar'
import policyDocument from './policy-document.ar'
import receipt from './receipt.ar'

export default {
  policyholderDetails,
  professionalInfo,
  quoteRequestStepper,
  declarations,
  quoteList,
  dashboard,
  drsLounge,
  summaryAndPayment,
  paymentResult,
  policyRenewal,
  quoteExpiredPopup,
  faq,
  cancellation,
  iban,
  ehsan,
  policyDocument,
  receipt,
} as const

export { default as drsLounge } from './drs-lounge.ar'
